<template>
  <div id="questionview">
    <v-container class="fill-height" fluid>
       <v-row align="center" justify="center"><h1>Bot Users</h1></v-row>
    </v-container>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64" ></v-progress-circular>
    </v-overlay>  
  </div>
   <div class="text-right mr-2">
      <v-btn color="primary" @click="assignmodel()">Assign Bots to Site</v-btn>
   </div>
   <v-data-table  :headers="headers"  :mobile-breakpoint="0"  :items="userList" >
     <template v-slot:item="{ item,index }"  >
       <tr :class="item.color">
          <td>{{ index+1 }}</td>
          <td class="text-left">{{ item.firstname }} {{ item.lastname }}</td>
          <td class="text-left">{{item.role}}</td>
          <td class="text-left"><img style="border-radius: 50%;" :src="item.filename" heigh="35" width="35"></td>
          <td>
            <div class="options">
              <v-icon small class="mr-2" @click="editItem(item,index)">mdi-pencil</v-icon>
            </div>
           </td>
        </tr>
      </template>   
     </v-data-table>    
     <v-dialog v-model="userdialog" max-width="650px">
        <v-card>
         <v-card-title><span>Edit User</span></v-card-title>
         <v-card-text>
           <v-container>
             <v-row>
               <v-col cols="6" sm="6" md="6">
                 <v-text-field v-model="editedItem.firstname" label="firstname"></v-text-field>
               </v-col>
               <v-col cols="6" sm="6" md="6">
                 <v-text-field v-model="editedItem.lastname" label="lastname"></v-text-field>
               </v-col>
             </v-row>
             <v-row>
               <v-col cols="6" sm="6" md="6">
                  <img :src="editedItem.filename" heigh="80" width="80">
               </v-col>
               <v-col cols="6" sm="6" md="6">
                <input type="file" id="files" ref="files"  v-on:change="handleFilesUpload()"/>
               </v-col>
             </v-row>
           </v-container>
         </v-card-text>
         <v-card-actions>
           <v-spacer></v-spacer>
           <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
           <v-btn color="blue darken-1" text @click="save">Save</v-btn>
         </v-card-actions>
        </v-card>
       </v-dialog>
       <v-dialog v-model="botmodel" max-width="650px">
        <v-card>
         <v-card-title><span>Assign Bots to Site</span></v-card-title>
         <v-card-text>
           <v-container>
             <v-row>
               <v-col cols="6" sm="6" md="6">
                    <v-select
          :items="sitesList"
           v-model="site"
           label="Select Site"
           item-text="name"
           item-value="id"
           outlined></v-select>
       
               </v-col>
               <v-col cols="6" sm="6" md="6">
                 <v-text-field v-model="totalbots" type="number" label="Total Number of Bots"></v-text-field>
               </v-col>
             </v-row>
           <div class="red--text text-center">{{ msg }}</div>
           </v-container>
         </v-card-text>
         <v-card-actions>
           <v-spacer></v-spacer>
           <v-btn color="blue darken-1" text @click="closemodel">Cancel</v-btn>
           <v-btn color="blue darken-1" text @click="saveSetting()">Save</v-btn>
         </v-card-actions>
        </v-card>
       </v-dialog>
 </div>   
</template>
<script>
export default {
  name: "Userslist",
  data() {
    return {
      overlay: false,
      userdialog:false,
      botmodel:false,
      site:'',
      totalbots:'',
      userList:[],
      editedItem:[],
      files:[],
      sitesList:[],
      index:'',
      msg:''
    };
  },
  computed: {
     headers(){
        let headers = [
              { text:"S.No", value: "" },
              { text:"Name  ",align: "question",value: "question",sortable: true},
              { text:"Role  ",value: "role"},
              { text:"Avatar  ",value: "avatar"},
              { text:"Action", value: "" },
         ]
         return headers
      },
    },    
  created(){
     this.overlay = true;
     this.getAllBotUser();
     this.$store.dispatch("getAllDamnnSites").then((response) => {
         this.sitesList = response.data;
     })
  },
  methods:{
    assignmodel(){
      this.botmodel = true;
    },
    getAllBotUser(){
        this.$store.dispatch("getBotUsers").then((response) => {
            this.overlay = false;
            this.userList = response.data;
        });
    },
    closemodel(){
     this.botmodel = false;
    },
    close(){
       this.editedItem = [];
       this.dialog     = false;
       this.addpayment='';
       this.sno1 = '';
       this.userdialog     = false;
    },
    handleFilesUpload(){
        let uploadedFiles = this.$refs.files.files;
         
        for( var i = 0; i < uploadedFiles.length; i++ ){
          this.files.push( uploadedFiles[i] );
        }
      },
     editItem(item,index){
       this.editedItem = item;
       this.userdialog     = true;
       this.index = index;
    },
    save(){
        
      var add_user_id = this.editedItem.id;
      var firstname   = this.editedItem.firstname;
      var lastname   = this.editedItem.lastname;
      let formData = new FormData();
      if(typeof this.files != "undefined")
      {
        formData.append('avatar', this.files[0]);
      } 
        
     formData.append('id', add_user_id);
     formData.append('firstname', firstname);
     formData.append('lastname', lastname);
  
      this.$store.dispatch("updatebot",
        formData
        ).then(() => {
          this.files = [];
         this.dialog = false;
         this.userdialog     = false;
         this.getAllBotUser();          
      });
    },
    saveSetting(){
      //console.log(this.site+" -- "+this.totalbots);
      this.$store.dispatch("assignBots",{site:this.site,bots:this.totalbots}).then((response) => {
        
           if(response.status){
              this.msg = 'Bot assigned to site job is under processing';
              this.site = '';
              this.totalbots = '';
              setTimeout(() => {
                this.botmodel = false;
                this.msg = '';
              }, 2000);
           }
      })
    }
  }
}  
</script>
